/* eslint-disable no-shadow */
/* eslint-disable */
/* eslint-disable max-lines-per-function */
import React, { useState, useEffect, useContext} from 'react';
import './dealStatus.scss';
import MagnifyingGlass from '../../Assets/images/svg/dar_magnifying.svg';
import DataGridComponent from '../../Components/DataGrid/dataGrid';
import {
  DEAL_TRANSITION_MASTER,
  DEAL_STATUS_HEADER,
  DEAL_STATUS_FIELD,
  ENABLE_DISABLE_DEALSTATUS_DLG,
} from '../../Constants/strings';
import ControlledSwitches from '../../Components/Switch/switch';
import UseAxios from '../../Api/http/http';
import { dealStatusList, enableOrDisableDealStatus } from '../../Api/request/dealStatus';
import { STATUS_CODES } from '../../Api/resources/statusCodes';
import SimpleSnackbar from '../../Components/Snackbar/snackbar';
import { AuthContext } from '../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../Constants/modules';
import PuzzleLoader from '../../Assets/images/svg/loading puzzle.gif';




const DealStatusMasterPage = () => {
  const [rows, setRows] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [isMobileView, setIsMobileView] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [severity, setSeverity] = useState('');

  const { userProfile } = useContext(AuthContext);
  
  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.MASTER_DEAL_STATUS] || []
    : [];

    const hasAccess = (action) => {
      return permission.includes(action);
    };
  


  const getDealStatusData = () => {
    setIsLoading(true);
    UseAxios(dealStatusList())
      .then((response) => {
        const dealStatuses = response.data.response.map((dealStatus) => ({
          ...dealStatus,
          id: dealStatus.status_id,
          active: !!dealStatus.active,
        }));
        setRows(dealStatuses);
        setIsLoading(false);
        })
      .catch((error) => {
        setRows([]);
        setIsLoading(false);
      });
  };

  const snackbarOpen = () => {
    setOpenSnackbar(true);
    setTimeout(() => {
      setOpenSnackbar(false);
    }, 1000);
  };


  useEffect(() => {
    getDealStatusData();
    checkMobileView();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);

  useEffect(() => {
    if (isEdit) {
      setIsEdit(false);
    }

  }, [rows])

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 768);
  };

  const handleSearch = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };

  const handleSwitchChange = async (rowToToggle) => {
    const updatedActiveStatus = !rowToToggle.active;
  
    const dealStatusData = {
      statusID: rowToToggle.id,
      active: updatedActiveStatus,
      };
  
    try {
      const response = await UseAxios(enableOrDisableDealStatus(dealStatusData));
        if (response.data.status === STATUS_CODES.SUCCESS) {
        const updatedRows = rows.map((row) => {
          if (row.id === dealStatusData.statusID) {
            return {
              ...row,
              active: updatedActiveStatus,
            };
          }
          return row;
        });
  
        setRows(updatedRows);
        setIsEdit(true);
      } else {
        let snackbarMessage = ENABLE_DISABLE_DEALSTATUS_DLG.OOPS_TRY_AGAIN;
        
        if (response.data.response.status === STATUS_CODES.INVALID_REQUEST) {
          snackbarMessage = ENABLE_DISABLE_DEALSTATUS_DLG.CANNOT_DISABLE;
        } 
        snackbarOpen();
        setSeverity('warning');
        setSnackbarMessage(snackbarMessage);
      }
    } catch (error) {
      snackbarOpen();
      setSeverity('error');
      setSnackbarMessage(ENABLE_DISABLE_DEALSTATUS_DLG.OOPS_TRY_AGAIN);
    }
  };
  

  const filteredRows =
    searchText.length >= 1
      ? rows.filter((dealStatusData) => {
        const text = searchText.toLowerCase();
        return (
          dealStatusData[DEAL_STATUS_FIELD.STATUS]
            ?.toLowerCase()
            .includes(text) ||
          dealStatusData[DEAL_STATUS_FIELD.REMARKS]
            ?.toLowerCase()
            .includes(text) ||
          dealStatusData[DEAL_STATUS_FIELD.UPDATED_BY]
            ?.toLowerCase()
            .includes(text)
        );
      })
      : rows;

     

  const desktopColumns = [
    {
      field: DEAL_STATUS_FIELD.STATUS,
      headerName: DEAL_STATUS_HEADER.STATUS,
      flex: 0.30,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: DEAL_STATUS_FIELD.REMARKS,
      headerName: DEAL_STATUS_HEADER.REMARKS,
      flex: 0.38,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: DEAL_STATUS_FIELD.UPDATED_BY,
      headerName: DEAL_STATUS_HEADER.UPDATED_BY,
      flex: 0.20,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span title={params.row.lastUpdatedTime}>
          {params.value}
        </span>
      ),
    },
    {
      field: DEAL_STATUS_FIELD.ACTIVE,
      headerName: DEAL_STATUS_HEADER.ENABLE_DISABLE,
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      flex: 0.16,
      renderCell: (params) => (
        <ControlledSwitches
        disabled={!hasAccess('update')}
        checked={params.value}
          handleChange={() => {
            handleSwitchChange(params.row);
          }}
        />
      ),
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const mobileColumns = [
    {
      field: DEAL_STATUS_FIELD.STATUS,
      headerName: DEAL_STATUS_HEADER.STATUS,
      width: 200,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: DEAL_STATUS_FIELD.REMARKS,
      headerName: DEAL_STATUS_HEADER.REMARKS,
      width: 200,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: DEAL_STATUS_FIELD.UPDATED_BY,
      headerName: DEAL_STATUS_HEADER.UPDATED_BY,
      width: 130,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span title={params.row.lastUpdatedTime}>
          {params.value}
        </span>
      ),
    },
    {
      field: DEAL_STATUS_FIELD.ACTIVE,
      headerName: DEAL_STATUS_HEADER.ENABLE_DISABLE,
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      width: 180,
      renderCell: (params) => (
        <ControlledSwitches
        disabled={!hasAccess('update')}
        checked={params.value}
          handleChange={() => {
            handleSwitchChange(params.row);
          }}
        />
      ),
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const columns = window.innerWidth <= 768 ? mobileColumns : desktopColumns;
  const sortFilterColumns = [columns[0].field, columns[1].field, columns[2].field,columns[3].field];

  return (
    <div className="deal-transition-master-outer-layer">
      <div className="deal-transition-master-map">
        <div className="deal-transition-master-map-title">{DEAL_TRANSITION_MASTER}</div>
        <div className="deal-transition-master-search-and-buttons">
          <div className="deal-transition-master-search">
            <img src={MagnifyingGlass} alt="Search" />
            <input
              id="deal-transition-master-search-input"
              type="text"
              placeholder="Search..."
              onChange={handleSearch}
            />
          </div>
        </div>
        <div className="data-grid-container">
          {isLoading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '20px',
              }}
            >
              <img
                src={PuzzleLoader}
                alt="Loading..."
                className="loader-gif"
                style={{ width: '100px', height: 'auto' }}
              />
            </div>
          ) : filteredRows ? (
            <DataGridComponent
              dataRows={filteredRows}
              dataColumns={isMobileView ? mobileColumns : desktopColumns}
              isFilteredRows={filteredRows}
              sortFilterColumns={sortFilterColumns}
              pageSize={10}
              isEdit={isEdit}
            />
          ) : null}
        </div>
        <SimpleSnackbar
        open={openSnackbar}
        message={snackbarMessage}
        severity={severity}
        alertCss={`'add-snackbar'} ${severity}`}
      />
      </div>
    </div>
  );
};
export default DealStatusMasterPage;
